import { render } from "./CarouselDb.vue?vue&type=template&id=406a1380&ts=true"
import script from "./CarouselDb.vue?vue&type=script&lang=ts"
export * from "./CarouselDb.vue?vue&type=script&lang=ts"

import "./CarouselDb.vue?vue&type=style&index=0&id=406a1380&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__